/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs */

const en_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uninterrupted focus, a must-have for Pomodoro users.`)
};

const ar_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تركيز غير منقطع، ضرورة لمستخدمي بومودورو.`)
};

const de_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ununterbrochene Konzentration, ein Muss für Pomodoro-Nutzer.`)
};

const es_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentración ininterrumpida, imprescindible para los usuarios de Pomodoro.`)
};

const fr_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La concentration sans interruption, indispensable à votre pratique du Pomodoro. 🍅`)
};

const it_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrazione ininterrotta, un must per gli utenti del Pomodoro.`)
};

const ja_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中力を途切れさせない。ポモドーロユーザーの必須機能`)
};

const ko_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`끊김 없는 집중, 포로도로 사용자를 위한 필수 아이템.`)
};

const pt_br_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foco sem interrupções, algo essencial para os usuários do Pomodoro.`)
};

const ru_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непрерывная фокусировка — то, что должно быть у приверженцев «Метода помидора».`)
};

const th_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การโฟกัสอย่างต่อเนื่องเป็นสิ่งจำเป็นสำหรับผู้ใช้ Pomodoro`)
};

const tr_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesintisiz odaklanma, Pomodoro kullanıcıları için olmazsa olmaz.`)
};

const zh_cn_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注不间断、番茄钟使用者必备`)
};

const zh_tw_subscription_exclusive_feature_break_autostart_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注不間斷、番茄鐘使用者必備`)
};

/**
* | output |
* | --- |
* | "Uninterrupted focus, a must-have for Pomodoro users." |
*
* @param {Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_break_autostart_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Break_Autostart_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_break_autostart_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_break_autostart_subtitle(inputs)
});